import { DOMAIN_ICON_DEFAULT_BACKGROUND_COLOR } from '@/constants/ui';
import React from 'react';

const MYOFunDomain = ({
  color,
  size = 50,
  background = DOMAIN_ICON_DEFAULT_BACKGROUND_COLOR,
}: {
  color: string;
  size?: number;
  background?: string;
}) => (
  <svg viewBox="0 0 100 100" width={size} height={size} fill={'none'}>
    <rect width="100" height="100" rx="18" fill={background} />
    <g clipPath="url(#clip0_41_4912)">
      <path
        d="M66.105 21.5104C66.9344 19.116 63.9577 17.246 62.1606 19.0326L29.8425 51.1616C28.3297 52.6656 29.3947 55.2476 31.5279 55.2476H38.5018C40.1736 55.2476 41.3291 56.9197 40.738 58.4835L33.278 78.22C32.3746 80.61 35.3465 82.5603 37.1796 80.7803L70.058 48.8554C71.5982 47.3598 70.5395 44.7496 68.3926 44.7496H61.413C59.7695 44.7496 58.6161 43.1295 59.1541 41.5765L66.105 21.5104Z"
        fill={color}
      />
    </g>
    <defs>
      <g clipPath="url(#clip0_41_4912)">
        <rect width="72" height="72" fill="white" transform="translate(14 14)" />
      </g>
    </defs>
  </svg>
);

export default MYOFunDomain;
